import nodeClient from "./node-client";

// Add/Save Bank
export const saveBank = async (formData) => {
  const response = await nodeClient.post(
    `/service/private/v0/bank/add`,
    formData
  );
  return response.data;
};

// List Banks
export const listBanks = async (query) => {
  const response = await nodeClient.post(
    `/service/private/v0/bank/list`,
    query
  );
  return response?.data?.result;
};

// List Banks
export const getBankList = async (query) => {
  const response = await nodeClient.post(
    `/service/private/v0/bank/list`,
    query
  );
  return response?.data;
};

// Filter Banks
export const filterBanks = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/bank/filteredList?${query}`
  );
  return response.data.result;
};
